import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import type { TimelineQueryOptions } from "@/marketing/models/campaignActivity";
import { campaignActivityAPIClient } from "../campaignActivityAPIClient";
import { CAMPAIGN_ACTIVITY_KEYS } from "./keys";

export const CAMPAIGN_ACTIVITY_QUERIES = {
  campaignTimeline: (campaignId: string, options: TimelineQueryOptions = {}) =>
    queryOptions({
      queryKey: CAMPAIGN_ACTIVITY_KEYS.campaignTimeline(campaignId),
      queryFn: () =>
        campaignActivityAPIClient.getCampaignTimeline(campaignId, options),
      placeholderData: keepPreviousData,
      staleTime: 30 * 1000,
      enabled: campaignId !== "",
    }),
  influencerTimeline: (
    campaignId: string,
    influencerId: string,
    options: TimelineQueryOptions = {},
  ) =>
    queryOptions({
      queryKey: CAMPAIGN_ACTIVITY_KEYS.influencerTimeline(
        campaignId,
        influencerId,
      ),
      queryFn: () =>
        campaignActivityAPIClient.getCampaignInfluencerTimeline(
          campaignId,
          influencerId,
          options,
        ),
      staleTime: 30 * 1000,
      enabled: campaignId !== "" && influencerId !== "",
    }),
};
